import React, {useCallback, useState} from "react";
import axios from "axios";
import * as Yup from "yup";
import {Alert, Button, Modal, TextInput} from "../common";
import {Form, Formik} from "formik";
import RegularText from "../common/_RegularText";
import StandardText from "../common/_StandardText";
import styles from "../common/_Modal/_Modal.module.scss";

const VALIDATION_SCHEMA = Yup.object().shape({
    ticket: Yup.string().required("formModal.required")
});

function DisableUserMFAModal({show, setShow, setDisableMFAAlertMessage, userId, mfaActivated, mfaRequired, mfaActivatedEmail}) {
    const [formError, setFormError] = useState(false);

    const handleClose = useCallback(() => {
        setFormError(false)
        setShow(false)
    }, [setShow]);

    const disableUserMFA = useCallback((ticketNumber) => {
        return axios.post("/api/approvals/create-request", {
            action: "disabling-user-mfa",
            reason: ticketNumber,
            details: {
                id: userId,
                ticketNumber: ticketNumber,
                mfaActivated: mfaActivated,
                mfaRequired: mfaRequired,
                mfaActivatedEmail: mfaActivatedEmail
            },
            attribute: "id",
            value: userId.toString()
        }).then(({data}) => {
            if (data.requestExists) {
                setFormError(true);
            } else {
                handleClose();
                const messageKey = data.pendingApproval
                    ? "specific.disableUserMFASuccess"
                    : "specific.disableUserMFAAutoApproved";
                setTimeout(() => setDisableMFAAlertMessage(null), 6000);
                setDisableMFAAlertMessage(messageKey);
            }
        });
    }, [userId, mfaActivated, mfaRequired, mfaActivatedEmail, setDisableMFAAlertMessage, handleClose]);

    const handleSubmit = useCallback((values, {setSubmitting}) => {
        setSubmitting(true);
        disableUserMFA(values.ticket)
            .finally(() => setSubmitting(false));
    }, [disableUserMFA]);

    return (
        <Modal header={"specific.modal.disableUserMFAHeader"} show={show} setShow={setShow} handleClose={handleClose}>
            <Formik
                initialValues={{ticket: ''}}
                validationSchema={VALIDATION_SCHEMA}
                onSubmit={handleSubmit}
            >
                {({
                    values,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    errors,
                    touched,
                    isSubmitting,
                }) => (
                    <Form onSubmit={handleSubmit}>
                        <b><label htmlFor="ticket">{<RegularText text={"specific.modal.disableUserMFAMessage"}/>}</label></b>
                        <TextInput id="ticket"
                            placeholder={"specific.modal.messagePlaceholder"}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.ticket}
                            errors={errors.ticket}
                            touched={touched.ticket}/>
                        {formError &&
                            <Alert variant={"danger"}><StandardText text={"specific.modal.userMFAAlreadyScheduled"}/></Alert>}
                        <Modal.Footer>
                            <Button label={"specific.modal.buttonCancel"} variant={"secondary"} onClick={handleClose} type="button"/>
                            <Button label={"specific.modal.disableUserMFAYes"} variant={"primary"} loading={isSubmitting}
                                type="submit" className={styles.submitButton}/>
                        </Modal.Footer>
                    </Form>
                )}
            </Formik>
        </Modal>
    );
}

export default DisableUserMFAModal;
